import React from 'react';
import styled from 'styled-components';
import { minBp, maxBp } from 'src/lib/theme';
import { BikeTitle } from './SummaryActions/SummaryActions.styled';

export const Wrap = styled.div`
  padding: 20px 20px 80px;
  height: 100%;

  @media ${minBp('tabletLarge')} {
    padding: 30px 20px 80px;
  }

  @media ${minBp('desktop')} {
    padding: 65px 40px 0 40px;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
`;

export const Outer = styled.div`
  @media ${minBp('desktop')} {
    width: calc(100% + 40px);
    flex: 1;
  }

  .ScrollbarsCustom {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .ScrollbarsCustom-Wrapper {
    position: relative;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;

    @media ${maxBp('desktop')} {
      overflow: inherit !important;
      position: relative !important;
    }

    @media ${minBp('desktop')} {
      right: 10px;
      overflow: hidden;
    }
  }

  .ScrollbarsCustom-Scroller {
    position: relative !important; // Override library rule
    overflow: inherit !important; // Override library rule
  }

  .ScrollbarsCustom-Content {
    box-sizing: border-box;
    padding: 0.05px;
    min-height: 100%;
    min-width: 100%;
  }

  .ScrollbarsCustom-TrackY {
    position: absolute;
    overflow: hidden;
    border-radius: 4px;
    user-select: none;
    width: 10px;
    right: 0px;
    top: 0;
    height: calc(100% - 40px);
    background: #d0cfd0;
  }

  .ScrollbarsCustom-ThumbY {
    touch-action: none;
    cursor: pointer;
    border-radius: 4px;
    width: 100%;
    height: 385.054px;
    transform: translateY(0px);
    background-color: #585a5f;
  }
`;

export const SummaryToggle = styled.button`
  ${({ theme }) => `
    margin: 0 0 30px;
    text-transform: uppercase;
    line-height: 1.25;
    font-family: ${theme.fonts.dinDemi};
    font-size: 12px;
    text-align: center;
    appearance: none;
    background: transparent;
    border: 0;
    border-bottom: 1px solid ${theme.colors.hairline};
    padding: 15px 0;
    width: 100%;

    svg {
      width: 13px;
      height: 13px;
      vertical-align: middle;
      position: relative;
      bottom: 2px;
      margin-left: 5px;
    }

    @media ${minBp('desktop')} {
      display: none;
    }
  `}
`;

export const SummaryToggleDesktop = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  vertical-align: middle;
  display: none;
  outline: none;

  @media ${minBp('desktop')} {
    display: inline-block;
  }
`;

export const Title = styled(BikeTitle)`
  @media ${minBp('desktop')} {
    margin-bottom: 20px;
  }
`;

export const Content = styled.div`
  @media ${minBp('desktop')} {
    padding-right: 40px;
  }
`;

export const BackToTop = styled.button`
  ${({ theme }) => `
    margin: 0 0 15px;
    text-transform: uppercase;
    line-height: 1.25;
    font-family: ${theme.fonts.dinDemi};
    font-size: 12px;
    text-align: center;
    appearance: none;
    background: transparent;
    border: 0;
    padding: 15px 0;
    width: 100%;

    svg {
      width: 13px;
      height: 13px;
      vertical-align: middle;
      position: relative;
      bottom: 2px;
      margin-left: 5px;
    }

    @media ${minBp('desktop')} {
      display: none;
    }
  `}
`;

export const BackButton = styled.div`
  padding: 5px;
  position: relative;
  bottom: 1px;
  left: -5px;
  margin-bottom: 10px;

  @media ${minBp('desktop')} {
    margin-bottom: 18px;
    position: relative;
    left: -10px;
  }

  svg {
    width: 16px;
    height: 16px;
    vertical-align: middle;

    @media ${minBp('desktop')} {
      vertical-align: top;
    }

    path {
      fill: #585a5f;
    }
  }
`;

export const BackButtonInner = styled.div`
  border: 1px solid #dad9d7;
  border-radius: 2px;
  padding: 4px 5px 2px 4px;
  background-color: rgba(255, 255, 255, 0.75);
  display: inline-block;
  line-height: 1;
  cursor: pointer;

  @media ${minBp('desktop')} {
    border: 0;
    padding: 0;
  }
`;

export const BackLabel = styled.span`
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  text-transform: uppercase;
  line-height: 0;
  color: #000;

  @media ${minBp('desktop')} {
    font-size: 20px;
  }
`;
